export const POSSIBLE_MOUSE_MODE_OBJECT: any = {
  single: ['bar', 'line', 'grid', 'control', 'scatter', 'heatmap', 'pie', 'wordcloud', 'boxplot', 'combine'],
  multi: ['bar', 'line', 'control', 'scatter', 'combine'],
  zoom: ['bar', 'line', 'scatter', 'control', 'boxplot', 'combine', 'waterfall', 'combine'],
};
